<app-main-header class="upload-datasets-header" [name_main]="pageTitle">
</app-main-header>

<section class="upload-datasets-page">
  <div
    class="split-grid"
    [class.is-resizing]="isResizingLayout"
    [style.--upload-pane-width.%]="uploadPaneWidthPercent">

    <!-- LEFT: Upload -->
    <section class="panel card-shell upload-panel">
      <div
        class="panel-header upload-panel-header"
        [class.upload-panel-header-file]="!!selectedFile"
        [class.upload-panel-header-csv]="selectedFileType === 'csv'"
        [class.upload-panel-header-xlsx]="selectedFileType === 'xlsx'">
        @if (selectedFile) {
          <div class="upload-file-header">
            <div class="upload-file-header-icon">
              <mat-icon>{{ isXlsx ? 'table_chart' : 'description' }}</mat-icon>
            </div>
            <div class="upload-file-header-copy">
              <h3 [matTooltip]="selectedFile.name" matTooltipPosition="above">{{ selectedFile.name }}</h3>
              <div class="upload-file-header-meta">
                <span>{{ selectedFileSizeLabel }}</span>
                <span class="upload-file-header-dot"></span>
                <span>{{ selectedFileType.toUpperCase() }}</span>
              </div>
              @if (schemaName || schemaId) {
                <span class="upload-schema-context">{{ schemaName || schemaId }}</span>
              }
            </div>
          </div>
        } @else {
          <div class="upload-header-text">
            <h3>{{ isTrackingSubmission ? 'Seguimiento de carga' : 'Cargar documento' }}</h3>
            @if (schemaName || schemaId) {
              <span class="upload-schema-context">{{ schemaName || schemaId }}</span>
            }
          </div>
        }

        <span class="status-chip"
          [class.status-chip-ready]="!!selectedFile && canSave"
          [class.status-chip-waiting]="(!selectedFile && !isTrackingSubmission) || (!!selectedFile && !canSave && !isSaving)"
          [class.status-chip-sent]="isSaving || isTrackingSubmission">
          {{ uploadHeaderStatusLabel }}
        </span>
      </div>

      <div
        #uploadPanelBody
        class="panel-body"
        [class.panel-body-centered]="!selectedFile && !isSaving && !isTrackingSubmission">

        @if (isSaving) {
          <div class="upload-progress-bar">
            <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
            <p class="upload-progress-label">
              <mat-icon>cloud_upload</mat-icon>
              Subiendo archivo al servidor...
            </p>
          </div>
        }

        <input #fileInput type="file" accept=".xlsx,.csv" (change)="onFileSelected($event)" hidden>

        @if (isTrackingSubmission) {
          @if (liveDataset$ | async; as live) {
            <section class="post-upload-state" [ngClass]="liveTrackerClass(live.validation_status)">
              <div class="post-upload-hero">
                <span class="post-upload-icon">
                  <mat-icon>{{ liveStatusIcon(live.validation_status) }}</mat-icon>
                </span>
                <span class="post-upload-status">{{ liveStatusLabel(live.validation_status) }}</span>
                <h4>{{ live.name || 'Archivo enviado' }}</h4>
                @if (!isLiveFailed(live.validation_status)) {
                  <p>{{ liveStatusDescription(live) }}</p>
                }
              </div>

              @if (isLiveProcessing(live.validation_status)) {
                <mat-progress-bar class="post-upload-progress" mode="indeterminate"></mat-progress-bar>
              }

              <div class="post-upload-stages" aria-label="Progreso de la carga">
                <div class="post-upload-stage is-done">
                  <span><mat-icon>check</mat-icon></span>
                  <small>Recibido</small>
                </div>
                <span class="post-upload-connector" [class.is-done]="hasReachedProcessing(live.validation_status)"></span>
                <div
                  class="post-upload-stage"
                  [class.is-done]="hasReachedResult(live.validation_status)"
                  [class.is-active]="isLiveProcessing(live.validation_status)">
                  <span><mat-icon>{{ hasReachedResult(live.validation_status) ? 'check' : 'sync' }}</mat-icon></span>
                  <small>Procesando</small>
                </div>
                <span class="post-upload-connector" [class.is-done]="hasReachedResult(live.validation_status)"></span>
                <div
                  class="post-upload-stage"
                  [class.is-success]="isLiveDone(live.validation_status)"
                  [class.is-error]="isLiveFailed(live.validation_status)">
                  <span><mat-icon>{{ isLiveFailed(live.validation_status) ? 'close' : 'check' }}</mat-icon></span>
                  <small>Resultado</small>
                </div>
              </div>

              @if (isLiveFailed(live.validation_status)) {
                @let parsed = parseValidationError(live);
                <div class="post-upload-error">
                  <div class="post-upload-error-head">
                    <span class="post-upload-error-icon"><mat-icon>error_outline</mat-icon></span>
                    <div class="post-upload-error-copy">
                      <strong>{{ liveStatusLabel(live.validation_status) }}</strong>
                      <p>{{ errorHeadline(live) }}</p>
                    </div>
                  </div>

                  @if (parsed && parsed.missing.length) {
                    <div class="post-upload-error-fields">
                      <span class="post-upload-error-fields-label">
                        <mat-icon>rule</mat-icon>
                        Faltan en tu archivo ({{ parsed.missing.length }})
                      </span>
                      <div class="missing-fields-chips">
                        @for (field of visibleMissingFields(parsed.missing); track field) {
                          <span class="missing-field-chip">{{ field }}</span>
                        }
                        @if (parsed.missing.length > missingFieldsPreviewCount) {
                          <button
                            type="button"
                            class="missing-fields-more"
                            (click)="showAllMissingFields = !showAllMissingFields">
                            {{ showAllMissingFields
                                ? 'Ver menos'
                                : '+' + (parsed.missing.length - missingFieldsPreviewCount) + ' más' }}
                          </button>
                        }
                      </div>
                    </div>
                  }

                  @if (parsed && parsed.extras.length) {
                    <div class="post-upload-error-fields">
                      <span class="post-upload-error-fields-label is-extra">
                        Columnas de más ({{ parsed.extras.length }})
                      </span>
                      <div class="missing-fields-chips">
                        @for (field of parsed.extras; track field) {
                          <span class="extra-field-chip">{{ field }}</span>
                        }
                      </div>
                    </div>
                  }

                  @if (parsed && parsed.detected.length) {
                    <div class="post-upload-error-fields">
                      <span class="post-upload-error-fields-label is-detected">
                        Encabezados detectados ({{ parsed.detected.length }})
                      </span>
                      <div class="missing-fields-chips">
                        @for (field of parsed.detected; track field) {
                          <span class="detected-field-chip">{{ field }}</span>
                        }
                      </div>
                    </div>
                  }

                  @if (parsed && parsed.raw) {
                    <details class="post-upload-error-raw">
                      <summary>Ver mensaje completo</summary>
                      <p>{{ parsed.raw }}</p>
                    </details>
                  }
                </div>
              }

              <div class="post-upload-actions">
                <button mat-stroked-button type="button" (click)="openLiveDetail(live)">
                  <mat-icon>visibility</mat-icon>
                  Ver detalle
                </button>
                @if (isLiveFailed(live.validation_status) && canRetryFailedUpload()) {
                  <button mat-stroked-button type="button" (click)="startNewUpload(fileInput)">
                    <mat-icon>add</mat-icon>
                    Realizar otra carga
                  </button>
                  <button mat-flat-button color="primary" type="button" (click)="retryFailedUpload()">
                    <mat-icon>refresh</mat-icon>
                    Corregir y reenviar
                  </button>
                } @else if (isLiveDone(live.validation_status) || isLiveFailed(live.validation_status)) {
                  <button mat-flat-button color="primary" type="button" (click)="startNewUpload(fileInput)">
                    <mat-icon>add</mat-icon>
                    Realizar otra carga
                  </button>
                }
              </div>
            </section>
          } @else {
            <section class="post-upload-state tracker-processing post-upload-waiting">
              <span class="post-upload-icon"><mat-icon>sync</mat-icon></span>
              <h4>Preparando el seguimiento</h4>
              <p>La carga fue recibida. Estamos consultando su estado.</p>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </section>
          }
        } @else if (!selectedFile) {
          <div
            class="dropzone"
            [class.drag-active]="isDragActive"
            (click)="onDropzoneClick($event, fileInput)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)">
            <div class="dropzone-empty">
              <!-- Ilustración placeholder (ícono). Reemplazable por un SVG a medida
                   dentro de .dropzone-illustration sin tocar el resto del layout. -->
              <div class="dropzone-illustration" [class.is-dragging]="isDragActive">
                <span class="dropzone-illustration-glow"></span>
                <span class="dropzone-illustration-badge">
                  <mat-icon>{{ isDragActive ? 'file_download' : 'upload_file' }}</mat-icon>
                </span>
              </div>

              <h4>{{ isDragActive ? 'Suelta el archivo para cargarlo' : 'Arrastra tu archivo aquí' }}</h4>
              <p>o selecciónalo desde tu equipo</p>

              <div class="dropzone-formats">
                <span class="format-pill"><mat-icon>description</mat-icon>CSV</span>
                <span class="format-pill"><mat-icon>table_chart</mat-icon>XLSX</span>
                <span class="format-hint">· un archivo por carga</span>
              </div>

              <div class="dropzone-actions">
                <button mat-flat-button color="primary" type="button" class="select-file-btn" (click)="fileInput.click()">
                  <mat-icon>folder_open</mat-icon>
                  Seleccionar archivo
                </button>
                <span
                  class="template-link-wrap"
                  [matTooltip]="schemaColumns.length ? 'Descarga un CSV con las columnas del schema y una fila de ejemplo' : 'Disponible cuando el schema tenga columnas configuradas'"
                  matTooltipPosition="above">
                  <button
                    mat-button
                    color="primary"
                    type="button"
                    class="template-link"
                    (click)="downloadTemplateCsv()"
                    [disabled]="!schemaColumns.length">
                    <mat-icon>download</mat-icon>
                    Descargar plantilla
                  </button>
                </span>
              </div>
            </div>
          </div>
        }

        @if (selectedFile) {
          <div class="operation-options">
            <div class="operation-card-list">
              @for (option of operationCards; track option.value) {
                <div
                  class="operation-card-shell"
                  [class.is-selected]="operationType === option.value"
                  [class.is-danger]="option.value === 'full_replace'">
                  <button
                    type="button"
                    class="operation-card"
                    [class.is-selected]="operationType === option.value"
                    [class.is-danger]="option.value === 'full_replace'"
                    (click)="operationType = option.value">
                    <span class="operation-card-icon">
                      <span class="operation-card-icon-glow"></span>
                      <mat-icon>{{ option.icon }}</mat-icon>
                    </span>
                    <span class="operation-card-text">
                      <strong>{{ option.title }}</strong>
                      <small>{{ option.description }}</small>
                    </span>
                    <span class="operation-card-state">
                      @if (operationType === option.value) {
                        <span class="operation-card-check-badge">
                          <mat-icon>check</mat-icon>
                        </span>
                      }
                      <mat-icon class="operation-card-check">
                        {{ operationType === option.value ? 'expand_less' : 'chevron_right' }}
                      </mat-icon>
                    </span>
                  </button>

                  @if (operationType === option.value) {
                    <div class="operation-card-detail">
                      @if (option.value === 'insert') {
                        <p class="operation-hint">Se agregarán nuevas filas al dataset. Esta opción no elimina información existente.</p>
                      }

                      @if (option.value === 'full_replace') {
                        <div class="operation-detail operation-detail-danger">
                          <div class="operation-detail-header">
                            <mat-icon>warning_amber</mat-icon>
                            <span>Reemplazo completo</span>
                          </div>
                          <p class="operation-hint">Se borrarán TODOS los datos actuales del dataset antes de cargar este archivo.</p>
                        </div>
                        <label class="operation-confirm">
                          <input type="checkbox" [(ngModel)]="fullReplaceConfirm">
                          Confirmo que quiero borrar todos los datos existentes
                        </label>
                      }

                      @if (option.value === 'replace_scope') {
                        <div class="operation-detail">
                          <div class="operation-detail-header">
                            <mat-icon>rule</mat-icon>
                            <span>Actualizar por columna</span>
                          </div>
                          <p class="operation-hint">Define una columna y un valor. Primero se eliminan esas coincidencias y luego se cargan las filas del archivo.</p>
                        </div>
                        <div class="scope-fields">
                          <div class="scope-field">
                            <label class="xlsx-label">Columna a comparar</label>
                            <p-dropdown
                              styleClass="operation-dropdown"
                              [options]="scopeColumnOptions"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Selecciona una columna"
                              appendTo="body"
                              [(ngModel)]="scopeColumn">
                            </p-dropdown>
                          </div>
                          <div class="scope-field">
                            <label class="xlsx-label">Valor a borrar</label>
                            <input class="xlsx-input" type="text" placeholder="ej: 2024" [(ngModel)]="scopeValueSingle">
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          @if (isXlsx) {
            <div class="xlsx-options" [class.is-expanded]="isXlsxOptionsExpanded">
              <button
                type="button"
                class="xlsx-options-toggle"
                [attr.aria-expanded]="isXlsxOptionsExpanded"
                aria-controls="xlsx-options-content"
                (click)="toggleXlsxOptions(uploadPanelBody)">
                <span class="xlsx-options-title">
                  <span class="xlsx-icon-wrap">
                    <mat-icon class="xlsx-icon">table_chart</mat-icon>
                  </span>
                  <span>
                    <strong>Opciones de Excel</strong>
                    <small>Hoja y fila de encabezados · opcional</small>
                  </span>
                </span>
                <mat-icon class="xlsx-toggle-icon">
                  {{ isXlsxOptionsExpanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>

              @if (isXlsxOptionsExpanded) {
                <div class="xlsx-options-content" id="xlsx-options-content">
                  <div class="xlsx-fields">
                    <div class="xlsx-field">
                      <label class="xlsx-label" for="xlsx-sheet-name">Nombre de la hoja</label>
                      <input
                        id="xlsx-sheet-name"
                        class="xlsx-input"
                        type="text"
                        placeholder="ej: Clientes"
                        [(ngModel)]="xlsxSheetName">
                    </div>
                    <div class="xlsx-field">
                      <label class="xlsx-label" for="xlsx-header-row">Fila de encabezados</label>
                      <input
                        id="xlsx-header-row"
                        class="xlsx-input xlsx-input-sm"
                        type="number"
                        min="1"
                        placeholder="ej: 1"
                        [(ngModel)]="xlsxHeaderRow">
                    </div>
                  </div>
                  <p class="xlsx-hint">
                    Déjalos vacíos para usar la primera hoja y la primera fila del archivo.
                  </p>
                </div>
              }
            </div>
          }
        }

      </div>

      @if (selectedFile) {
        <div class="upload-actions" aria-label="Acciones de carga">
          <button
            mat-stroked-button
            type="button"
            class="cancel-upload-btn"
            (click)="cancelSelectedFile(fileInput)"
            [disabled]="isSaving">
            Cancelar
          </button>
          <button mat-flat-button class="send-btn" [disabled]="!canSave" (click)="saveDataset()">
            <mat-icon>{{ isSaving ? 'sync' : 'cloud_upload' }}</mat-icon>
            {{ isSaving ? 'Enviando...' : 'Enviar carga' }}
          </button>
        </div>
      }
    </section>

    <div
      class="resize-handle"
      [class.is-disabled]="!canResizeLayout"
      (pointerdown)="startHorizontalResize($event)"
      matTooltip="Arrastra para ampliar o reducir la sección de carga"
      matTooltipPosition="above"
      aria-label="Redimensionar sección de carga"
      role="separator">
      <span class="resize-handle-grip"></span>
    </div>

    <!-- RIGHT: Schema + History (50/50) -->
    <div class="right-stack">

      <section class="panel card-shell schema-panel">
        <div class="panel-header schema-panel-header">
          <div class="schema-title-line">
            <h3>Estructura del modelo de datos</h3>
            @if (schemaDetails?.description; as desc) {
              <mat-icon
                class="schema-info-icon"
                [matTooltip]="desc"
                matTooltipPosition="above">info</mat-icon>
            }
          </div>
          @if (schemaColumns.length) {
            <button
              mat-stroked-button
              type="button"
              class="schema-detail-btn"
              (click)="openSchemaStructure()">
              <mat-icon>visibility</mat-icon>
              Ver detalle
            </button>
          }
        </div>

        @if (!isSchemaLoading && schemaDetails && schemaColumns.length) {
          <div class="schema-summary">
            <div class="summary-chips">
              <button
                type="button"
                class="summary-chip chip-cols"
                [class.is-active]="columnFilter === 'all'"
                [attr.aria-pressed]="columnFilter === 'all'"
                matTooltip="Ver todas las columnas"
                (click)="columnFilter = 'all'">
                <mat-icon>view_column</mat-icon>
                <span class="summary-chip-count">{{ schemaColumns.length }}</span>
                <span class="summary-chip-label">columnas</span>
              </button>
              <button
                type="button"
                class="summary-chip chip-req"
                [class.is-active]="columnFilter === 'required'"
                [attr.aria-pressed]="columnFilter === 'required'"
                [disabled]="!requiredColumnsCount"
                matTooltip="Ver solo requeridas"
                (click)="columnFilter = 'required'">
                <mat-icon>check_circle</mat-icon>
                <span class="summary-chip-count">{{ requiredColumnsCount }}</span>
                <span class="summary-chip-label">requeridas</span>
              </button>
            </div>

            <label class="schema-search">
              <mat-icon>search</mat-icon>
              <input
                type="search"
                placeholder="Buscar columna"
                aria-label="Buscar columna"
                [(ngModel)]="columnSearch">
              @if (columnSearch) {
                <button
                  type="button"
                  class="schema-search-clear"
                  aria-label="Limpiar búsqueda"
                  (click)="columnSearch = ''">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </label>
          </div>
        }

        <div class="panel-body schema-body">
          @if (!schemaId) {
            <div class="schema-picker">
              <mat-icon class="schema-picker-icon">table_view</mat-icon>
              <h4>Elige un modelo de datos</h4>
              <p>Selecciona el schema al que quieres cargar datos para ver su estructura y habilitar la carga.</p>
              @if (isSchemasListLoading) {
                <p class="empty-copy">Cargando schemas disponibles...</p>
              } @else if (schemasListError) {
                <p class="empty-copy error-copy">{{ schemasListError }}</p>
              } @else if (!schemaPickerOptions.length) {
                <p class="empty-copy">No hay schemas disponibles para seleccionar.</p>
              } @else {
                <p-dropdown
                  styleClass="schema-picker-dropdown"
                  [options]="schemaPickerOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecciona un schema"
                  [filter]="true"
                  filterBy="label"
                  appendTo="body"
                  [(ngModel)]="schemaPickerValue"
                  (onChange)="onSchemaPicked($event.value)">
                </p-dropdown>
              }
            </div>
          } @else if (isSchemaLoading) {
            <div class="schema-chip-grid" aria-label="Cargando columnas" aria-busy="true">
              @for (skeleton of schemaSkeletonSlots; track skeleton) {
                <div class="schema-column-chip is-skeleton">
                  <span class="skeleton-block skeleton-icon"></span>
                  <span class="skeleton-block skeleton-label"></span>
                  <span class="skeleton-block skeleton-badge"></span>
                </div>
              }
            </div>
          } @else if (schemaLoadError) {
            <p class="empty-copy error-copy">{{ schemaLoadError }}</p>
          } @else if (schemaColumns.length) {
            @if (displayedColumns.length) {
              <div class="schema-chip-grid">
                @for (column of displayedColumns; track column.name) {
                  <button
                    type="button"
                    class="schema-column-chip"
                    [class.is-required-col]="column.required"
                    [matTooltip]="getColumnTooltip(column)"
                    matTooltipPosition="left"
                    matTooltipClass="col-detail-tooltip">
                    <span class="schema-type-icon type-{{ column.data_type || 'text' }}">
                      <mat-icon>{{ getColumnTypeIcon(column.data_type) }}</mat-icon>
                    </span>
                    <span class="col-label">{{ column.label || column.name }}</span>
                    @if (column.required) {
                      <span class="req-star" aria-label="Requerida">*</span>
                    }
                    <span class="type-badge type-{{ column.data_type || 'text' }}">{{ column.data_type || 'text' }}</span>
                  </button>
                }
              </div>
            } @else {
              <p class="empty-copy">
                No hay columnas que coincidan
                @if (columnFilter === 'required') { con el filtro de requeridas }
                @if (columnSearch) { con "{{ columnSearch }}" }.
              </p>
            }
          } @else {
            <p class="empty-copy">Este modelo de datos no tiene columnas configuradas.</p>
          }
        </div>
      </section>

      <section class="panel card-shell history-panel">
        <div class="panel-header history-header">
          <h3>Historial</h3>
          @if (history.embeddedTotalPages() > 1) {
            <div class="history-pager">
              <button
                type="button"
                class="history-pager-btn"
                (click)="history.embeddedPrevPage()"
                [disabled]="!history.embeddedHasPrev()"
                aria-label="Página anterior">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="history-pager-label">{{ history.embeddedPageLabel() }}</span>
              <button
                type="button"
                class="history-pager-btn"
                (click)="history.embeddedNextPage()"
                [disabled]="!history.embeddedHasNext()"
                aria-label="Página siguiente">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        </div>
        <div class="history-body">
          <app-list-collector-datasets
            #history
            [schemaIdInput]="schemaId"
            [schemaNameInput]="schemaName">
          </app-list-collector-datasets>
        </div>
      </section>

    </div>
  </div>
</section>
